import { gql } from '@apollo/client'

export const SHOP_CART_FULFILLMENT_ADDRESS_FRAGMENT = gql`
  fragment ShopCartFulfillmentAddress on ShopCartFulfillmentAddress {
    address1
    address2
    city
    cityGooglePlaceId
    country
    countryIsoCode
    firstName
    lastName
    latitude
    longitude
    stateIsoCode
    zipCode
  }
`
